import pImg4 from '../images/case/jagdish.jpg'
import pImg5 from '../images/case/hetram-jangu.jpg'
import pImg6 from '../images/case/dinesh.JPG'
import tImg1 from '../images/case/icon_angular.svg'
import tImg2 from '../images/case/icon_elephent.svg'
import tImg3 from '../images/case/icon_netcore.svg'
import tImg4 from '../images/case/vuejs.svg'
import tImg5 from '../images/case/icon_python.svg'


const Project = [
   
    {
        Id: '7',
        pImg: pImg4,
        title: 'Jagdish Prasad [Founder & CEO]',
        slug: 'jagdish-prasad',
        sub: 'Software development',
        Industry: 'Software development',
        Country: 'India',
        Technologies1: tImg1,
        Technologies2: tImg2,
        description: 'With 24+ years of experience in web and software development, Jagdish leads Anuwebsolutions with a vision to create cutting-edge digital solutions. His expertise in **Shopify,  WordPress, React, and PHP** ensures that every project meets the highest standards of quality and performance.',

    },
    {
        Id: '8',
        pImg: pImg5,
        title: 'Hetram Janghu [Full-Stack Developer]',
        slug: 'Hetram-Janghu',
        sub: 'Healthcare',
        Industry: 'Wellness & Fitness',
        Country: 'India',
        Technologies1: tImg1,
        Technologies2: tImg3,
        description: 'A coding expert with proficiency in React.js,Magento, Node.js, Laravel, and mobile app development, Rahul is responsible for building high-performance applications that are secure, scalable, and efficient.',
    },
    {
        Id: '9',
        pImg: pImg6,
        title: 'Dinesh Kaswan',
        slug: 'dinesh-kaswan',
        sub: 'Senior Software Engineer',
        Industry: 'Real estate',
        Country: 'India',
        Technologies1: tImg4,
        Technologies2: tImg5,
        description: 'I am a Tech Lead having several years of experience in Magento. Have experience in development of Web sites and applications using JavaScript, Cakephp, Angular JS and PHP as primary languages and Frameworks like MySQL, HTML5, VueJS. I also have experience in front end development using Web Applications and Git as secondary languages along with AJAX and Jquery',
    },
   

]

export default Project;